module.exports = __webpack_public_path__ + "static/img/jizhuangxiang.ae53db2a.jpg";